var render, staticRenderFns
import script from "./RodeCarouselComponent.vue?vue&type=script&lang=js&"
export * from "./RodeCarouselComponent.vue?vue&type=script&lang=js&"
import style0 from "./RodeCarouselComponent.vue?vue&type=style&index=0&id=3004b900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3004b900",
  null
  
)

export default component.exports